<template>
<!-- S : 마이팩 일반결제 : 주문제품 보기 -->
<!-- S : 마아팩 주문제품 보기 -->
  <div class="order_wrap">
    <div class="accordion_item-a" v-if="!isGroupOrder">
      <div class="accordion_title">주문제품 보기<button type="button" class="btn_open"><span class="a11y">열기</span></button></div>
      <div class="accordion_content-b">
        <div class="box_product product_list-type">
          <!-- S : product item title -->
          <div class="product_item cart-thead">
            <div class="product_col-summery">
              <p class="txt_cart-thead">
                제품
              </p>
            </div>
            <div class="product_col-panels">
              <p class="txt_cart-thead">
                수량
              </p>
            </div>
            <div class="product_col-price box_product-price">
              <p class="txt_cart-thead">
                단가(원) / 소계(원)
              </p>
            </div>
          </div>
          <!-- E : product item title -->
          <!-- S : product_item(재고없음) -->
          <div
            v-for="product in orderProducts"
            :key="product.item_sku"
            class="product_item"
          >
            <div class="product_col-summery">
              <div class="box_product-summery">
                <div class="summery_col-thumb" v-if="product.item_name != '포장비'">
                  <a
                    :href="product.outlink"
                    class="link_product"
                  ><img :src="product.img_url"></a>
                </div>
                <div class="summery_col-thumb" v-else>
                  <img :src="product.img_url">
                </div>

                <div class="summery_col-info">
                  <a :href="product.outlink" class="link_product" v-if="product.item_name != '포장비'">
                    <div class="product_text-data">
                      <p class="text_product-title">{{ product.item_name }}</p>
                    </div>
                  </a>
                  <div class="product_text-data" v-else>
                    <p class="text_product-title">{{ product.item_name }}</p>
                  </div>

                  <!-- S : 2020-02-28 AS-IS add -->
                  <promotion-tooltip-info v-if="product.promotionYN" />
                  <!-- E : 2020-02-28 AS-IS add -->

                  <div class="box_mobile-price box_product-price">
                    <div class="text_product-state">
                      <div class="state_title">
                        수량
                      </div>
                      <div class="state_contents">
                        <span class="state_data"><mpn-label-number :amount="product.dose_cnt" /></span>
                      </div>
                    </div>
                    <div class="text_product-price unit">
                      <div class="price_title">
                        단가
                      </div>
                      <div class="price_contents">
                        <span class="text_price-data"><mpn-label-number :amount="product.price" /></span>원
                      </div>
                    </div>
                    <div class="text_product-price">
                      <div class="price_title">
                        소계
                      </div>
                      <div class="price_contents">
                        <span class="text_price-data">
                          <mpn-label-number :amount="product.price*product.dose_cnt" />
                        </span>원
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="product_col-panels">
              <div class="text_product-state">
                <div class="state_title">
                  수량
                </div>
                <div class="state_contents">
                  <span class="state_data"><mpn-label-number :amount="product.dose_cnt" /></span>
                </div>
              </div>
            </div>
            <div class="product_col-price box_product-price">
              <div class="text_product-price unit">
                <div class="price_title">
                  단가
                </div>
                <div class="price_contents">
                  <span class="text_price-data"><mpn-label-number :amount="product.price" /></span>원
                </div>
              </div>
              <div class="text_product-price">
                <div class="price_title">
                  소계
                </div>
                <div class="price_contents">
                  <span class="text_price-data">
                    <mpn-label-number :amount="product.price*product.dose_cnt" />
                  </span>원
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- S : 마이팩 일괄주문결제 : 주문제품 보기 -->
    <div class="bulk_order" v-else>
      <h3 class="service-title">마이팩 일괄 주문 내역</h3>

      <!-- S : 마아팩 일괄주문제품 보기 아이템 -->
      <div class="accordion_item-a" v-for="(order, index) in groupOrderProducts" :key="index">
        <div class="accordion_title">
          주문제품 보기 <span>{{ order.mypackName }}</span>
          <button type="button" class="btn_open"><span class="a11y">열기</span></button>
        </div>
        <div class="accordion_content-b">
          <div class="box_product product_list-type">
            <!-- S : product item title -->
            <div class="product_item cart-thead">
              <div class="product_col-summery">
                <p class="txt_cart-thead">제품</p>
              </div>
              <div class="product_col-panels">
                <p class="txt_cart-thead">수량</p>
              </div>
              <div class="product_col-price box_product-price">
                <p class="txt_cart-thead">단가(원) / 소계(원)</p>
              </div>
            </div>
            <!-- E : product item title -->
            <!-- S : product_item(재고없음) -->
            <div class="product_item" v-for="product in order.orderProducts" :key="product.item_sku">
              <div class="product_col-summery">
                <div class="box_product-summery">
                  <div class="summery_col-thumb" v-if="product.item_name != '포장비'"><a :href="product.outlink" class="link_product" target="_blank"><img :src="product.img_url"></a></div>
                  <div class="summery_col-thumb" v-else><img :src="product.img_url"></div>
                  <div class="summery_col-info">
                    <a :href="product.outlink" target="_blank" class="link_product" v-if="product.item_name != '포장비'">
                      <div class="product_text-data">
                        <p class="text_product-title">{{ product.item_name }}</p>
                      </div>
                    </a>
                    <div class="product_text-data" v-else>
                      <p class="text_product-title">{{ product.item_name }}</p>
                    </div>

                    <div class="box_mobile-price box_product-price">
                      <div class="text_product-state">
                        <div class="state_title">수량</div>
                        <div class="state_contents"><span class="state_data"><mpn-label-number :amount="product.dose_cnt" /></span></div>
                      </div>
                      <div class="text_product-price unit">
                        <div class="price_title">단가</div>
                        <div class="price_contents"><span class="text_price-data"><mpn-label-number :amount="product.price" /></span>원</div>
                      </div>
                      <div class="text_product-price">
                        <div class="price_title">소계</div>
                        <div class="price_contents"><span class="text_price-data"><mpn-label-number :amount="product.total_price" /></span>원</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="product_col-panels">
                <div class="text_product-state">
                  <div class="state_title">수량</div>
                  <div class="state_contents"><span class="state_data"><mpn-label-number :amount="product.dose_cnt" /></span></div>
                </div>
              </div>
              <div class="product_col-price box_product-price">
                <div class="text_product-price unit">
                  <div class="price_title">단가</div>
                  <div class="price_contents"><span class="text_price-data"><mpn-label-number :amount="product.price" /></span>원</div>
                </div>
                <div class="text_product-price">
                  <div class="price_title">소계</div>
                  <div class="price_contents"><span class="text_price-data"><mpn-label-number :amount="product.total_price" /></span>원</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- E : 마아팩 일괄주문제품 보기 아이템 -->
    </div>
    <!-- E : 마이팩 일괄주문결제 : 주문제품 보기 -->
    <!-- E : product_item(재고없음) -->
    <ul class="dot-list-a mt_10"><!-- 2020-11-26 추가-->
      <li>더블엑스 주문 수량은 [골드, 실버, 그린 각 1정 씩 포함된 한 세트]의 주문 수량입니다.</li>
    </ul>
    <div class="bottom_action-area center">
      <a
        class="btn_default-b medium"
        @click="$router.push('/mypacks')"
      >주문내역 확인</a>
      <a
        class="btn_default-a medium"
        @click="$router.push('/')"
      >마이팩 메인</a>
      <button
        type="button"
        class="btn_default-a medium pc_block"
        @click="print"
      >
        인쇄
      </button>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import orderHelpers from '@/utils/helpers/order';
import PromotionTooltipInfo from '@/components/PromotionTooltipInfo.vue';

export default {
  name: 'OrderProducts',
  components: {
    PromotionTooltipInfo,
  },
  props: {
    orderResult: {
      type: Object,
      default: null,
    },
    isGroupOrder: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      orderProducts: [],
      groupOrderProducts: []
    };
  },
  computed: {
    ...mapGetters({
      products: 'product/products',
    }),
  },
  created() {
    // 그룹오더 여부에 따라 주문제품정보 분기 처리
    if(this.isGroupOrder){
        this.orderResult.group_product_info.forEach(item => {
          this.groupOrderProducts.push({
            orderProducts: orderHelpers.refineOrderedProducts(this.products, item.product_info, this.orderResult.appliedProductPromotions),
            mypackName: item.mypack_name
          });
        });
    }else {
      this.orderProducts = orderHelpers.refineOrderedProducts(
        this.products,
        this.orderResult.product_info,
        this.orderResult.appliedProductPromotions,
      );
    }

  },
  mounted() {
    $('.accordion_item-a').uxeAccordionMenu({
      'clickedShowOnly': true,
      'navigation' : '.btn_open',
      'itemContents' : '.accordion_content-b',
    }, !this.isGroupOrder ? $('.accordion_item-a')[0]: null);
  },
  methods: {
    print() {
      window.print();
    },
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/order/complete/partial/OrderProducts.vue